import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

import "./PriceList.css";
import Process from "../Home/Process/Process"
import Header from "../Shared/Header/Header";
import SubHeader from '../Shared/SubHeader/SubHeader';
import Footer from "../Shared/Footer/Footer";
import Specialities from "../Home/Specialities/Specialities";

const PriceList = () => {
  const services = [
    {
      name: "Diagnoza ADHD",
      price: "500 zł",
      link: "/oferta",
    },
    {
      name: "Diagnoza Autyzmu",
      price: "800 zł",
      link: "/oferta",
    },
    {
      name: "Diagnoza Zaburzeń Lękowych",
      price: "300 zł",
      link: "/oferta",
    },
    {
      name: "Diagnoza Zaburzeń Osobowości",
      price: "600 zł",
      link: "/oferta",
    },
    {
      name: "Konsultacje psychologiczne",
      price: "200 zł",
      link: "/oferta",
    }
  ];

  return (
    <>
      <Header/>
      <SubHeader title="Cennik" subtitle="Świadczymy profesjonalne usługi w niskich cenach dostępnych dla każdego." />
      
      <div style={{backgroundColor:"#f9f9f9", paddingTop:"2rem", paddingBottom:"1rem"}}>
        <div className="mb-5 section-title text-center">
              <h2>Cennik usług</h2>
        </div>
        <div
          className="pricelist-container"
          // style={{ marginBottom: "4rem", marginTop: "2rem"}}
        >
          <div className="p-4" style={{ backgroundColor: "#f8f9fa", borderRadius: "8px", marginTop: "0rem"}}>
            
            {services.map((service, index) => (
              <div
                key={index}
                className="d-flex justify-content-between align-items-center py-2 border-bottom"
              >
                <div className="fw-medium" style={{ flex: "1" }}>{service.name}</div>
                <div className="text-muted me-5">{service.price}</div>
                <Link 
                to={service.link} className=".pricelist-custom-link d-flex align-items-center" 
                style={{ textDecoration: "none", fontSize: "0.9rem", color:"hsl(274, 60%, 50%)"}}
                >
                  Szczegóły <FaArrowRight className="ms-1" style={{color: "hsl(274, 60%, 50%)"}}/>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="price-list-wrapper">
        <Specialities />
      </div>
      <Process />
      <Footer />
    </>
  );
};

export default PriceList;